module.exports = __webpack_public_path__ + "static/media/circle-chevron-up.3f6858ba.svg";